var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLightbulb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.54199 18.125H13.792",
    stroke: "#5B6772",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.91706 13.1267C6.1452 12.5493 5.51774 11.8009 5.08396 10.9401C4.65018 10.0793 4.4219 9.12965 4.41706 8.16576C4.40143 4.77513 7.128 1.95482 10.5186 1.8767C11.8438 1.84583 13.1445 2.2371 14.2327 2.99396C15.321 3.75081 16.1404 4.83407 16.5726 6.08718C17.0048 7.34029 17.0274 8.69837 16.6371 9.96517C16.2468 11.232 15.4639 12.3419 14.4014 13.1345C14.2113 13.2809 14.0574 13.4691 13.9518 13.6845C13.8461 13.8999 13.7914 14.1368 13.7921 14.3767C13.7921 14.5425 13.7262 14.7014 13.609 14.8186C13.4918 14.9358 13.3328 15.0017 13.1671 15.0017H8.16706C8.0013 15.0017 7.84233 14.9358 7.72512 14.8186C7.60791 14.7014 7.54206 14.5425 7.54206 14.3767V14.3611C7.54207 14.1207 7.4855 13.8837 7.37692 13.6693C7.26835 13.4548 7.11081 13.269 6.91706 13.1267V13.1267Z",
    stroke: "#5B6772",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4092 7.5C13.2932 6.98273 13.0326 6.50908 12.6578 6.13424C12.2829 5.75939 11.8093 5.49879 11.292 5.38281",
    stroke: "#5B6772",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulb);
export default __webpack_public_path__ + "static/media/Lightbulb.f1f2ce534730c03ecbb9b660fd9c51c5.svg";
export { ForwardRef as ReactComponent };